import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useToast } from "../../../components/admin/ToastContext";
import { PageHeader } from "../../../components/admin/EssUi";

const SECTIONS = [
  "General","Leave Policies","Attendance Rules","Expense Limits","Payroll Settings",
  "Appraisal Cycles","Recruitment","Training","Document Templates","Notification Rules",
  "User Roles","Integrations","Audit Trail",
];

const POLICY_CARDS = [
  {
    title: "Annual Leave",
    rows: [["Days/year","18 days"],["Carry-over max","5 days"],["Notice required","7 days"],["Half-day allowed","Yes"]],
    color: "#eef2ff",
  },
  {
    title: "Sick Leave",
    rows: [["Days/year","12 days"],["Medical cert required","After 2 days"],["Carry-over","No"],["Advance booking","No"]],
    color: "#f0fdf4",
  },
  {
    title: "Compensatory",
    rows: [["How earned","Approved overtime"],["Expiry","3 months"],["Max accumulation","10 days"],["Manager approval","Yes"]],
    color: "#fffbeb",
  },
  {
    title: "Maternity / Paternity",
    rows: [["Maternity","14 weeks"],["Paternity","10 days"],["Paid","100%"],["Notice required","30 days"]],
    color: "#fdf2f8",
  },
];

const GENERAL_FIELDS = [
  { label: "Company Name", value: "Lewoo SARL / Africa Systems" },
  { label: "Country", value: "Cameroon" },
  { label: "Time Zone", value: "Africa/Douala (WAT - UTC+1)" },
  { label: "Working Days", value: "Monday - Friday" },
  { label: "Working Hours", value: "08:00 - 17:00 (8h/day)" },
  { label: "Self-Service Portal URL", value: "https://ess.lewoo.cm" },
  { label: "Allow Remote Work Requests", value: "Yes" },
  { label: "Require Manager Approval", value: "All leave types" },
];

const ESSAdminSettingsPage = () => {
  const intl = useIntl();
  const addToast = useToast();
  const [activeSection, setActiveSection] = useState("General");

  const handleSave = () => {
    addToast(intl.formatMessage({ id: "ess.admin.settings.saved" }), "success");
  };

  return (
    <div className="max-w-7xl mx-auto animate-fade-in">
      <PageHeader
        title={intl.formatMessage({ id: "ess.admin.settings.title" })}
        subtitle={intl.formatMessage({ id: "ess.admin.settings.subtitle" })}
      />

      <div style={{ display: "grid", gap: 20 }} className="ess-rg-side">
        <div className="ess-card p-4">
          {SECTIONS.map((s) => (
            <div
              key={s}
              onClick={() => setActiveSection(s)}
              style={{
                padding: "10px 12px",
                borderRadius: 8,
                fontSize: 13,
                fontWeight: activeSection === s ? 600 : 500,
                cursor: "pointer",
                marginBottom: 2,
                background: activeSection === s ? "#eef2ff" : "transparent",
                color: activeSection === s ? "#4f46e5" : "#334155",
              }}
            >
              {s}
            </div>
          ))}
        </div>

        <div>
          {activeSection === "General" && (
            <>
              <div className="ess-card" style={{ padding: 20, marginBottom: 16 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: "#1e293b", marginBottom: 20 }}>
                  ⚙️ General ESS Settings
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                  {GENERAL_FIELDS.map((f) => (
                    <div key={f.label} className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                      <div style={{ fontSize: 12, fontWeight: 600, color: "#475569", minWidth: 180 }}>{f.label}</div>
                      <input className="ess-inp" style={{ flex: 1 }} value={f.value} readOnly />
                    </div>
                  ))}
                  <button
                    onClick={handleSave}
                    className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-lg text-sm font-medium transition-all shadow-sm"
                    style={{ background: "#4f46e5", color: "white", width: "fit-content" }}
                  >
                    {intl.formatMessage({ id: "ess.admin.settings.save" })}
                  </button>
                </div>
              </div>

              <div className="ess-card" style={{ padding: 20 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: "#1e293b", marginBottom: 16 }}>
                  📋 Leave Policy Defaults
                </div>
                <div style={{ display: "grid", gap: 16 }} className="ess-rg-2">
                  {POLICY_CARDS.map((card) => (
                    <div key={card.title} className="ess-card" style={{ padding: 14, borderRadius: 10, background: card.color }}>
                      <div style={{ fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".04em", color: "#64748b", marginBottom: 8 }}>{card.title}</div>
                      {card.rows.map(([label, value]) => (
                        <div key={label} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "5px 0", borderBottom: "1px solid #f1f5f9" }}>
                          <span style={{ color: "#64748b" }}>{label}</span>
                          <span style={{ fontWeight: 600 }}>{value}</span>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}

          {activeSection !== "General" && (
            <div className="ess-card" style={{ padding: 40, textAlign: "center" }}>
              <span className="text-4xl mb-3 block">⚙️</span>
              <p style={{ fontWeight: 500, color: "#64748b", marginBottom: 4 }}>{activeSection}</p>
              <p style={{ fontSize: 13, color: "#94a3b8" }}>Configuration section — coming soon</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ESSAdminSettingsPage;
